import React from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
const AbuseChRansomAdapterDocumentation = () => {
  const { t } = useTranslation("integrations");
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    Alert,
    {
      style: { marginBottom: 10 },
      bsStyle: "warning",
      title: t("abusech_ransom_adapter_documentation.deprecation_title")
    },
    /* @__PURE__ */ React.createElement("p", null, t("abusech_ransom_adapter_documentation.deprecation_text"))
  ));
};
export default AbuseChRansomAdapterDocumentation;
